import React from 'react';

import SearchBox from './SearchBox';
import Layout from '../shared/Layout';
import AskTheExpert from './AskTheExpert';

const LearnHeader = () => (
  <Layout.Header>
    <div className="LearnHeader-search">
      <SearchBox />
      <AskTheExpert />
    </div>
  </Layout.Header>
);

export default LearnHeader;
